import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IPagedInvoiceResultRequestDto } from 'src/app/models/backend';
import { IInvoicesDto } from 'src/app/models/backend/invoices';
import { PagedListingComponentBase } from 'src/app/shared/components/paged-listing-component-base';
import { InvoicesService } from './invoices.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { RetailersService } from '../retailers/retailers.service';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../login/login.service';
import { environment } from 'src/environments/environment';
import { RetailerPlanType } from 'src/app/models/enums/retailerPlanType';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent extends PagedListingComponentBase<IInvoicesDto> {
  protected override delete(entity: IInvoicesDto): void {
    throw new Error('Method not implemented.');
  }
  myModel: any;
  keyword: any = '';
  invoiceSortingTypes: any[] = [];
  selectedInvoiceSortingTypes: number | null = 2;

  today: any = new Date();
  dayOfWeek = this.today.getDay();
  diff: any = this.today.getDate() - this.dayOfWeek + (this.dayOfWeek === 0 ? -6 : 1);
  mondayOfWeek: any = new Date(this.today.setDate(this.diff));

  startDate: Date = new Date();
  endDate: Date = new Date();

  loader = false;

  boolCustom = false;
  Retailers: any
  ddlRetailer: any

  selectedRetailer = 0;
  searchQuery: string = '';
  isDropdownOpen: boolean = false;

  actualAmount: number = 0
  paid: number = 0
  Unpaid: number = 0
  Total: number = 0

  //disable for submit button
  isdisable = true

  request: IPagedInvoiceResultRequestDto = {
    isInvoledDeletedItems: false,
    skipCount: 0,
    maxResultCount: 100,
    endDate: this.endDate,
    // isTestMode: true,
    retailerId: 0,
    startDate: this.startDate
  };
  @Output("updated") updated = new EventEmitter<boolean>();
  Role: any
  RetailerId = localStorage.getItem("RetailerId")
  data: any
  totalItemsCount = 0
  filteredRetailers = [];

  constructor(
    private dialog: MatDialog,
    private modalService: NgbModal,
    private invoiceService: InvoicesService,
    public router: Router,
    public loginService: LoginService,
    private retailerService: RetailersService, private toastr: ToastrService
  ) {
    super();
    this.Role = localStorage.getItem("RoleType")
    this.getRetailers()
    this.startDate.setDate(this.startDate.getDate() - 1);
    // this.list()
  }

  dialogConfig = new MatDialogConfig();
  invoices: IInvoicesDto[] = [];

  isRefresh(refresh: boolean) { if (refresh === true) this.getDataPage(1); }

  protected override async list(request: IPagedInvoiceResultRequestDto, pageNumber: number) {
    // this.loader=true
    // if(localStorage.getItem("TestMode")=='true'){
    //   this.request.isTestMode=true
    // }
    // else{
    //   this.request.isTestMode=false
    // }
    this.request.startDate=this.startDate
    await this.invoiceService.getInvoices(this.request).subscribe((res: any) => {
      this.invoices = res.pagedResultDto.items.map(item =>({
        ...item,
        retailerPlanType:RetailerPlanType[item.retailerPlanType]
      }));
      console.log('mapped invoices',this.invoices);
      // this.actualAmount=res.pagedResultDto.item.actualAmount

      this.loader = false
      this.showPaging(res, pageNumber)

    })
  }

  onPageChanged(pageNumber: number) {
    this.request = {
      isInvoledDeletedItems: false,
      skipCount: (pageNumber - 1) * 100,
      maxResultCount: 100,
      endDate: this.endDate,
      // isTestMode: true,
      retailerId: 0,
      startDate: this.startDate
    }
    // if(localStorage.getItem("TestMode")=='true'){
    //   this.request.isTestMode=true
    // }
    // else{
    //   this.request.isTestMode=false
    // }
    this.list(this.request, pageNumber,)
    this.getDataPage(pageNumber);
  }

  onChangeFilter() {
    // this.getDataPage(1);
  }
  onSelectChange(selectedValue) {
    console.log(selectedValue.value)
    selectedValue = selectedValue.value
    const today = new Date();
    const dayOfWeek = today.getDay();
    const year = today.getFullYear();
    const month = today.getMonth();
    const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    const mondayOfWeek = new Date(today.setDate(diff));
    this.boolCustom = false
    switch (selectedValue) {
      case '1': // Today
        this.startDate = mondayOfWeek;
        this.endDate = new Date(today.setDate(diff + 6));
        // this.startDate = new Date();
        // this.endDate = new Date();
        break;
      case '2': // Yesterday
        const yesterday = new Date();
        this.startDate = mondayOfWeek;
        this.endDate = new Date(today.setDate(diff + 6));
        // yesterday.setDate(yesterday.getDate() - 1);
        // this.startDate = yesterday;
        // this.endDate = yesterday;
        break;
      case '3': // This week
        this.startDate = mondayOfWeek; // Set start date to Monday
        const endOfWeek = new Date(mondayOfWeek); // Create a new Date for the end of the week
        endOfWeek.setDate(mondayOfWeek.getDate() + 6); // Set to Sunday
        this.endDate = endOfWeek; // Set end date
        break;
      case '4': // Last Week
        const lastMonday = new Date(mondayOfWeek);
        lastMonday.setDate(lastMonday.getDate() - 7);
        const lastSunday = new Date(mondayOfWeek);
        lastSunday.setDate(lastSunday.getDate() - 1);
        this.startDate = lastMonday;
        this.endDate = lastSunday;
        break;
      case '5': // This Month
        const firstDayOfMonth = new Date(Date.UTC(year, month, 1));
        const lastDayOfMonth = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59, 999));
        // const firstDayOfMonth = new Date(year, month, 1);
        // const lastDayOfMonth = new Date(year, month + 1, 0);
        this.startDate = firstDayOfMonth;
        this.endDate = lastDayOfMonth;
        break;
      case '6': // Last Month
        const firstDayOfLastMonth = new Date(Date.UTC(year, month - 1, 1));
        const lastDayOfLastMonth = new Date(Date.UTC(year, month, 0, 23, 59, 59, 999));
        this.startDate = firstDayOfLastMonth;
        this.endDate = lastDayOfLastMonth;
        break;
      case '7': // Custom 
        this.boolCustom = true
        this.startDate = null;
        this.endDate = null;
        break;

      default:
        this.startDate = new Date();
        this.endDate = new Date();
        break;
    }
    // this.list(this.request, 1)
    // console.log(this.startDate, this.endDate)
    // this.request={
    //   isTestMode:false,
    //   endDate:this.endDate,
    //   maxResultCount:10,
    //   skipCount:0,
    //   startDate:this.startDate,
    //   isInvoledDeletedItems:false,
    //   retailerIds:[]
    // }
    // this.invoiceService.getInvoices(this.request).subscribe((res:any)=>{
    //   console.log(res)
    //   this.invoices=res.items
    // })
  }
  async Filter() {
    this.loader = true
    console.log(this.selectedRetailer)
    console.log(this.startDate, this.endDate)
    //this.list(this.request, 1)
    this.request = {
      // isTestMode:false,
      endDate: this.endDate,
      maxResultCount: 100,
      skipCount: 0,
      startDate: this.startDate,
      isInvoledDeletedItems: false,
      retailerId: this.selectedRetailer
    }
    console.log(this.request)
    await this.invoiceService.getInvoices(this.request).subscribe((res: any) => {
      this.invoices = res.pagedResultDto.items.map(item =>({
        ...item,
        retailerPlanType:RetailerPlanType[item.retailerPlanType]
      }));
      // this.invoices = res.items
      this.paid = res.paid
      this.Unpaid = res.unPaid
      this.Total = res.total
      this.actualAmount = res.actual
      this.loader = false
      console.log('invoice', res)
    })
  }
  getRetailers() {
    var request = {
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      Keyword: ""
    }
    this.loader = true
    this.retailerService.GetRetailers(request).subscribe((res: any) => {
      this.Retailers = res.items
      this.ddlRetailer = res.items
      this.filteredRetailers = [...this.Retailers];
      console.log(this.filteredRetailers)
      this.loader = false
    })
  }

  selectRetailer(retailer: any) {
    this.selectedRetailer = retailer;
    console.log(this.selectedRetailer)
    this.isDropdownOpen = false;
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  filterRetailer: any
  filterRetailers() {
    const filterValue = this.filterRetailer.toLowerCase();
    this.filteredRetailers = this.Retailers.filter(m =>
      m.fullName.toLowerCase().includes(filterValue)
    );

    if (filterValue === "") {
      this.getRetailers(); // Reset to original list if input is empty
    }
  }
  // filterRetailers(filterValue) {
  //   this.Retailers = this.ddlRetailer
  //   console.log(filterValue.value)
  //   var filter
  //   filter = this.Retailers.filter(m => m.fullName.toLowerCase().includes(filterValue.value.toLowerCase()));
  //   this.Retailers = filter
  //   console.log(filter)
  //   if (filterValue.value == "" || filterValue.value == null) {
  //     this.getRetailers()
  //   }
  //   if (filter == "") {
  //     return
  //   }
  //   return
  // }
  UpdateInvoice(unPaidAmount, invoiceId, retailerId, invoiceNumber, invoiceUnPaidAmount) {
    let request = {
      paidAmount: unPaidAmount,
      invoiceId: invoiceId,
      retailerId: retailerId,
      invoiceNumber: invoiceNumber,
      // isTestMode: false
    }
    if (unPaidAmount > invoiceUnPaidAmount) {
      this.toastr.error('Entered amount is greater than Unpaid Amount', 'error')
      // Swal.fire('Entered amount is greater than Unpaid Amount', '', 'error')
      return
    }

    Swal.fire({
      title: 'Are you sure want to update invoice?',
      text: 'You will not be able to recover this',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, update it!',
      cancelButtonText: 'No, cancel it'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Updated!',
          'Invoice has been updated.',
          'success'
        )
        this.invoiceService.createInvoicePayment(request).subscribe((res: any) => {
          this.list(this.request, 1)
        })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Invoice is not updated',
          'warning'
        )
      }
    })

  }

  isPostPaid(input:string){
    return RetailerPlanType[input]==RetailerPlanType.Postpaid
  }
  async exportDataPDF() {
    
    this.loader = true
    this.request.maxResultCount = 100;
   await this.invoiceService.getInvoices(this.request).subscribe((res: any) => {
      this.data = res.pagedResultDto.items
      console.log('invoices download',res.pagedResultDto.items);;
      this.exportToPDF(this.data, "Invoice Report.pdf")
      this.loader = false

    })
  }
  exportToPDF(data: any[], filename: string) {
    const doc = new jsPDF();
    if (this.data.length == 0) {
      doc.text("No data available", 14, 16)
      doc.save(filename)
      return
    }
    const pdfHeaders = ["Retailer Name", "", "EndDate", "Actual Amount", "Paid", "UnPaid", "Total"]
    const tableData = data.map(row => [
      row.retailer,
      row.startDate,
      row.endDate,
      row.actualAmount,
      row.paidAmount,
      row.unPaidAmount,
      row.totalAmount

    ]);
    doc.text('Invoice Report', 14, 16);
    (doc as any).autoTable({
      head: [pdfHeaders],
      body: tableData,
      startY: 22,
      styles: { fontSize: 7 },
    });
    doc.save(filename)
  }
  exportData() {
    this.loader = true
    this.request.maxResultCount = 100
    console.log(this.request)
    this.invoiceService.getInvoices(this.request).subscribe((res: any) => {
      this.data = res.pagedResultDto.items
      const selectedHeaders =
      {
        retailer: 'Retailer Name', startDate: 'StartDate', endDate: 'EndDate',
        actualAmount: 'Actual Amount', paidAmount: 'Paid Amount',
        unPaidAmount: 'UnPaid Amount', totalAmount: 'Total'
      }
      this.exportToCSV(this.data, 'Invoice Report.csv', selectedHeaders);
      this.loader = false
    })
  }
  exportToCSV(data: any[], filename: string, headerMapping: { [key: string]: string }) {
    if (data.length === 0) {
      alert("No data found to export")
      return;
    }

    const dataKeys = Object.keys(data[0]);
    const invalidHeaders = Object.keys(headerMapping).filter(header => !dataKeys.includes(header));
    if (invalidHeaders.length) {
      console.error('Invalid headers in mapping:', invalidHeaders);
      return;
    }
    const customHeaders = Object.values(headerMapping);
    const csvRows = [];

    csvRows.push(customHeaders.join(','));
    for (const row of data) {
      csvRows.push(Object.keys(headerMapping)
        .map(key => JSON.stringify(row[key], (key, value) => value === null ? '' : value))
        .join(',')
      );
    }
    const csvBlob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    saveAs(csvBlob, filename);
  }

  PrintRecipt(id) {
    debugger;
    const url = this.router.serializeUrl(
      this.router.createUrlTree([environment.appNameUrl + `downloadinvoice/id${id}`])
    )
    window.open(url, '_blank')
  }
  // logout() {
  //   this.loginService.logout();
  // }

}
